import { NavBarNames } from '../../config/NavBarNameList';

export function getCurrentRouteName(location) {
  const isBelongsToTab = (tab) => location?.toLowerCase()?.indexOf(tab) > -1;
  if (location === '/') {
    return NavBarNames.dashboard;
  }
  if (isBelongsToTab('/campaigns')) {
    return NavBarNames.campaigns;
  }
  if (isBelongsToTab('campaign') && isBelongsToTab('category')) {
    return NavBarNames.campaignCategory;
  }
  if (isBelongsToTab('mission')) {
    return NavBarNames.mission;
  }
  if (isBelongsToTab('coupon') && isBelongsToTab('records')) {
    return NavBarNames.couponRecords;
  }
  if (isBelongsToTab('coupon')) {
    return NavBarNames.coupons;
  }
  if (isBelongsToTab('earn')) {
    return NavBarNames.earnRules;
  }
  if (isBelongsToTab('customer') && isBelongsToTab('group')) {
    return NavBarNames.customerGroup;
  }
  if (isBelongsToTab('custom')) {
    return NavBarNames.customer;
  }
  if (isBelongsToTab('segments')) {
    return NavBarNames.segments;
  }
  if (isBelongsToTab('levels')) {
    return NavBarNames.levels;
  }
  if (isBelongsToTab('message')) {
    return NavBarNames.message;
  }
  if (isBelongsToTab('rewards')) {
    return NavBarNames.rewards;
  }
  if (isBelongsToTab('brands')) {
    return NavBarNames.brands;
  }
  if (isBelongsToTab('stores')) {
    return NavBarNames.stores;
  }
  if (isBelongsToTab('store') && isBelongsToTab('category')) {
    return NavBarNames.storeCategory;
  }
  if (isBelongsToTab('translations')) {
    return NavBarNames.translations;
  }
  if (isBelongsToTab('transactions')) {
    return NavBarNames.transactions;
  }
  if (isBelongsToTab('spot_check')) {
    return NavBarNames.spotCheck;
  }
  if (isBelongsToTab('point') && isBelongsToTab('records')) {
    return NavBarNames.pointRecords;
  }
  if (isBelongsToTab('administrator_groups')) {
    return NavBarNames.adminGroup;
  }
  if (isBelongsToTab('administrators')) {
    return NavBarNames.admin;
  }
  if (isBelongsToTab('banners')) {
    return NavBarNames.banners;
  }
  if (isBelongsToTab('product') && isBelongsToTab('categories')) {
    return NavBarNames.productCategory;
  }
  if (isBelongsToTab('what_is_new')) {
    return NavBarNames.whatsNewCampaign;
  }
  if (isBelongsToTab('discover_campaigns')) {
    return NavBarNames.featuredCampaign;
  }
  if (isBelongsToTab('greeting_card')) {
    return NavBarNames.greetingCard;
  }
  if (isBelongsToTab('greeting_section')) {
    return NavBarNames.greetingSection;
  }
  if (isBelongsToTab('featured') && isBelongsToTab('products')) {
    return NavBarNames.featuredProduct;
  }
  if (isBelongsToTab('feedback')) {
    return NavBarNames.feedbackList;
  }
  if (isBelongsToTab('guide_image')) {
    return NavBarNames.guideImage
  }
  if (isBelongsToTab('afc_settings')) {
    return NavBarNames.afcSetting
  }
  if (isBelongsToTab('afc_data_record')) {
    return NavBarNames.afcDataRecords
  }
  if (isBelongsToTab('afc_cronjob_record')) {
    return NavBarNames.afcCronJobRecords
  }
  if (isBelongsToTab('afc_account_binding_record')) {
    return NavBarNames.afcAccountLogs
  }
  if (isBelongsToTab('communities')) {
    return NavBarNames.community
  }
  if (isBelongsToTab('news_feeds')) {
    return NavBarNames.newsFeed
  }
  if (isBelongsToTab('part1_progressive_profiling')) {
    return NavBarNames.part1ProgressiveProfiling
  }
  if (isBelongsToTab('part2_progressive_profiling')) {
    return NavBarNames.part2ProgressiveProfiling
  }
  if (isBelongsToTab('barcodes')) {
    return NavBarNames.barcodeListing
  }
  if (isBelongsToTab('barcode_validate')) {
    return NavBarNames.validateNewBarcode
  }
  if (isBelongsToTab('splash_ad')) {
    return NavBarNames.splashAd
  }
  if (isBelongsToTab('reward_code')) {
    return NavBarNames.rewardCode
  }
}
